const kinds = new Set(['admission', 'center', 'report', 'result_delivery', 'technologist']);

export function normalizeSurveyForm(value, expectedKind) {
    if (!value || !kinds.has(value.survey_kind) || (expectedKind && value.survey_kind !== expectedKind)) {
        throw new Error('این لینک برای فرم نظرسنجی دیگری صادر شده یا نوع فرم نامعتبر است.');
    }
    if (typeof value.title !== 'string' || !value.title.trim() ||
        !Number.isInteger(value.version) || value.version < 0 ||
        !Array.isArray(value.sections) || !value.sections.length || value.sections.length > 50) {
        throw new Error('اطلاعات فرم نظرسنجی کامل نیست. لطفاً با کلینیک تماس بگیرید.');
    }
    const keys = new Set();
    const sections = value.sections.map(item => {
        if (!item || typeof item.key !== 'string' || !/^[a-zA-Z0-9_-]{1,50}$/.test(item.key) ||
            keys.has(item.key) || typeof item.label !== 'string' || !item.label.trim()) {
            throw new Error('معیارهای فرم نظرسنجی نامعتبر هستند.');
        }
        keys.add(item.key);
        return { key: item.key, label: item.label };
    });
    return { id: value.id, survey_kind: value.survey_kind, title: value.title, version: value.version, sections };
}

export function buildSurveyAnswers(sections, ratings) {
    return sections.map(({ key }) => {
        const rating = ratings[key];
        if (!Number.isInteger(rating) || rating < 1 || rating > 5)
            throw new Error('لطفاً به تمام موارد نظرسنجی امتیاز دهید.');
        return { section: key, rating };
    });
}
